import { Controller } from "stimulus"

export default class extends Controller {
    static targets = [ "container", "input" ]

    connect() {
       console.log("Providers list controller connected!")
       console.log("Container target exists:", this.hasContainerTarget)
       console.log("Input target exists:", this.hasInputTarget)
       this.selectedIndex = -1
    }

    findProviders(event) {
      console.log("findProviders called with value:", event.target.value)
      
      // Handle arrow key navigation
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault()
        this.navigateList(event.key === 'ArrowDown' ? 1 : -1)
        return
      }
      
      // Handle Enter key
      if (event.key === 'Enter') {
        event.preventDefault()
        this.selectCurrentItem()
        return
      }
      
      // Handle Escape key
      if (event.key === 'Escape') {
        this.closeList()
        return
      }
      
      if (!this.hasContainerTarget) {
        console.error("Container target not found")
        return
      }
      
      // Reset selection when typing
      this.selectedIndex = -1
      
      fetch(`/providers/list?query=${event.target.value}`, {
        method: 'GET',
        headers: {'Accept': 'text/plain' }
      })
      .then(response => response.text())
      .then((data) => {
        this.containerTarget.classList.remove("d-none")
        this.containerTarget.innerHTML = data
        this.updateListStyles()
      })
      .catch(error => {
        console.error("Error fetching providers:", error)
      })
    }

    navigateList(direction) {
      if (!this.hasContainerTarget || this.containerTarget.classList.contains("d-none")) {
        return
      }
      
      const items = this.containerTarget.querySelectorAll('.provider-item')
      if (items.length === 0) return
      
      // Remove previous selection
      items.forEach(item => item.classList.remove('selected'))
      
      // Update selected index
      this.selectedIndex += direction
      
      // Handle boundaries
      if (this.selectedIndex < -1) {
        this.selectedIndex = items.length - 1
      } else if (this.selectedIndex >= items.length) {
        this.selectedIndex = -1
      }
      
      // Highlight selected item
      if (this.selectedIndex >= 0) {
        const selectedItem = items[this.selectedIndex]
        selectedItem.classList.add('selected')
        selectedItem.scrollIntoView({ block: 'nearest' })
      }
    }

    selectCurrentItem() {
      if (!this.hasContainerTarget || this.selectedIndex < 0) {
        return
      }
      
      const items = this.containerTarget.querySelectorAll('.provider-item')
      if (items[this.selectedIndex]) {
        this.setProvider({ currentTarget: items[this.selectedIndex] })
        this.closeList()
      }
    }

    updateListStyles() {
      // Ensure proper z-index and positioning
      if (this.hasContainerTarget) {
        this.containerTarget.style.zIndex = '9999'
        this.containerTarget.style.position = 'absolute'
        
        // Add styling to items for better UX
        const items = this.containerTarget.querySelectorAll('.provider-item')
        items.forEach((item, index) => {
          item.style.textAlign = 'left'
          item.style.padding = '8px 12px'
          item.style.cursor = 'pointer'
          item.style.borderBottom = '1px solid #eee'
          
          // Add hover effect
          item.addEventListener('mouseenter', () => {
            this.selectedIndex = index
            items.forEach(i => i.classList.remove('selected'))
            item.classList.add('selected')
          })
          
          item.addEventListener('mouseleave', () => {
            item.classList.remove('selected')
            this.selectedIndex = -1
          })
        })
      }
    }

    setProvider(event) {
      if (!this.hasInputTarget) {
        console.error("Input target not found")
        return
      }
      const providerName = event.currentTarget.innerText.trim()
      this.inputTarget.value = providerName
      this.closeList()
      
      // Navigate to the search results
      const form = this.inputTarget.closest('form')
      if (form) {
        form.submit()
      }
    }

    closeList() {
      if (!this.hasContainerTarget) {
        console.error("Container target not found")
        return
      }
      this.containerTarget.classList.add("d-none")
      this.selectedIndex = -1
    }
}